<div>
    <table mat-table [dataSource]="historialPoseedor"  class="w-full">
            <!-- coleccionista Column -->
            <ng-container matColumnDef="coleccionista">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                    Coleccionista
                </th>
                <td mat-cell *matCellDef="let poseedor"> {{poseedor.nombreColeccionista}} </td>
            </ng-container>

            <!-- Nombre Column -->
            <ng-container matColumnDef="registroAnterior">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                    Registro Anterior
                </th>
                <td mat-cell *matCellDef="let poseedor"> {{poseedor.registroAnterior}} </td>
            </ng-container>

            <!-- fecha Column -->
            <ng-container matColumnDef="fecha">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                    Fecha
                </th>
                <td mat-cell *matCellDef="let poseedor"> {{poseedor.fechaCreacion | date : 'mediumDate'}} </td>
            </ng-container>

            <!-- operadoPor Column -->
            <ng-container matColumnDef="operadoPor">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 border-r">
                    Operado Por
                </th>
                <td mat-cell *matCellDef="let poseedor"> {{poseedor.creadoPor.nombreCompleto}} </td>
            </ng-container>

            
            <tr mat-header-row *matHeaderRowDef="columns" class="bg-gray-300 h-10"></tr>
            <tr mat-row *matRowDef="let row; columns: columns" class="border-b"></tr>
        </table>
</div>